import { Link } from "react-router-dom";

export default function Hero() {
  return (
    <section id="hero" className="hero d-flex align-items-center">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 d-flex flex-column justify-content-center">
            <h1 data-aos="fade-up">
              Empowering Businesses with
              <span style={{ color: "#0070f3" }}> Intelligent Technology </span>
              Solutions
            </h1>
            <h2 data-aos="fade-up" data-aos-delay="400">
              From custom software and web platforms to AI-driven automation and cloud infrastructure — we architect digital ecosystems that fuel sustainable growth.
            </h2>
            <div data-aos="fade-up" data-aos-delay="600">
              <div className="text-center text-lg-start">
                <Link
                  to="/contact"
                  className="btn-get-started scrollto d-inline-flex align-items-center justify-content-center align-self-center"
                >
                  <span>Start Your Project</span>
                  <i className="bi bi-arrow-right" />
                </Link>
                <Link
                  to="/services"
                  className="btn btn-outline-primary ms-3"
                  style={{ padding: "12px 28px", borderRadius: "50px" }}
                >
                  <span>Explore Services</span>
                  <i className="bi bi-gear ms-2" />
                </Link>
              </div>
            </div>
          </div>
          <div className="col-lg-6 hero-img" data-aos="zoom-out" data-aos-delay="200">
            <img
              src="img/hero-img.png"
              className="img-fluid"
              alt="SDtech Solutions — Technology partner for business growth"
            />
          </div>
        </div>

        <div className="row mt-5" data-aos="fade-up" data-aos-delay="800">
          <div className="col-12 text-center">
            <p style={{ color: "#6c757d", fontSize: "15px", marginBottom: 0 }}>
              Trusted by <strong>150+</strong> Businesses Worldwide |
              <strong> 200+</strong> Projects Delivered |
              <strong> 16+</strong> Service Categories |
              <strong> 5+</strong> Years of Excellence
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}